import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DFDaysOfWeek, DFInstances, DFMonthlyDataRequest, DaysOfWeeks, FixedChargesFrequency, FrequencyTime,
  TimeZone, days, fixedChargeFrequency, searchFrequency, DFMonthlyDataDto } from 'app/df-management/shared/df-admin-country.model';
import { DfManagementService } from 'app/df-management/shared/df-management.service';
import { LoaderService } from 'app/shared/services/loader.service';
import { NavigationService } from 'app/shared/services/navigation.service';
import * as moment from 'moment';
import { Moment } from 'moment';
import { IDatePickerDirectiveConfig } from 'ng2-date-picker';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CalendarStatusService } from '../../calendar-status.service';
import { CountryService } from '../../country.service';
import { CalendarService } from '../../calendar.service';

@Component({
  selector: 'app-add-country-form',
  templateUrl: './add-country-form.component.html',
  styleUrls: ['./add-country-form.component.scss']
})
export class AddCountryFormComponent implements OnInit {
  @Output() countryEmitter = new EventEmitter();
  @Output() countryClickEmitter = new EventEmitter();

  isPopupModel = false;
  @Input() isFlag: boolean;
  countryForm: FormGroup;
  myForm: FormGroup;
  dateConfig: IDatePickerDirectiveConfig;
  dayConfig: IDatePickerDirectiveConfig;
  @Input()
  maxDate: Moment;
  @Input()
  minDate: Moment;
  isShowInputBox = false;
  isSequencial = false;
  isAssetSearch = false;
  isLoadSearch = false;
  isAutoCalculateSearch = false;
  isVoucherSearch = false;
  assetSearchTime: string;
  sequencialSearchTime: string;
  voucherJobSearchTime: string;
  loadSearchTime: string;
  autoCalculateSearchTime: string;
  isChecked: boolean;
  sequencialTimeData: DFDaysOfWeek;
  assetTimeData: DFDaysOfWeek;
  loadTimeData: DFDaysOfWeek;
  autoCalculateTimeData: DFDaysOfWeek;
  voucherTimeData: DFDaysOfWeek;
  daysOfSequencialTime: DFInstances;
  daysOfAssetTime: DFInstances;
  daysOfLoadTime: DFInstances;
  daysOfAutoCalculateTime: DFInstances;
  daysOfVoucherTime: DFInstances;
  daysOfSequencialWeeks: DaysOfWeeks[] = [];
  daysOfAssetWeeks: DaysOfWeeks[] = [];
  daysOfLoadWeeks: DaysOfWeeks[] = [];
  daysOfAutoCalculateWeeks: DaysOfWeeks[] = [];
  daysOfVoucherWeeks: DaysOfWeeks[] = [];
  SchedulersFrequency: DFInstances;
  assetSearchFrequency: DFInstances;
  loadSearchFrequency: DFInstances;
  autoCalculateFrequency: DFInstances;
  voucherJobFrequency: DFInstances;
  sequencialListOfDays: DFDaysOfWeek[] = [];
  assetListOfDays: DFDaysOfWeek[] = [];
  loadListOfDays: DFDaysOfWeek[] = [];
  autoCalculateListOfDays: DFDaysOfWeek[] = [];
  voucherListOfDays: DFDaysOfWeek[] = [];
  timeZoneList: TimeZone[];
  specificDateSequencial: string;
  specificDateAsset: string;
  specificDateLoad: string;
  specificDateCalculate: string;
  specificDateVoucher: string;
  selectedCheckSequencialboxes: Set<string> = new Set();
  selectedCheckVoucherboxes: Set<string> = new Set();
  selectedCheckAssetboxes: Set<string> = new Set();
  selectedCheckloadboxes: Set<string> = new Set();
  selectedCheckAutoCalboxes: Set<string> = new Set();
  fixedChargeFrequency = fixedChargeFrequency;
  searchFrequency = searchFrequency;
  days = days;
  isDisbledSequencialButton = true;
  timeSelection: string;
  isShowFrequency = false;
  onboardCountryCode: string;
  isShowFrequencyContent = false;
  fixedCharge: string;
  initialVoucherCharge = 1;
  isModalOpen = false;
  years: number[] = [];
  monthsOnSelectedYears: any[] = [];
  selectedYear: any;
  countryCode: string;
  calendarStatus = false;
  constructor(private fb: FormBuilder,
    private dfManagementService: DfManagementService,
    private toastr: ToastrService,
    private loader: LoaderService,
    private translate: TranslateService,
    public navigationService: NavigationService,
    private router: Router,
    private calendarstatusService: CalendarStatusService,
    private countryService: CountryService,
    private calendarService: CalendarService,
    private cd: ChangeDetectorRef
    ) {
  }

  ngOnInit(): void {
    this.countryForm = this.fb.group({
      countryCode: [null, Validators.required],
      countryName: [null, Validators.required],
      timeZone: [null, Validators.required],
      fixedChargesFrequency: [null, Validators.required],
      selectSchedulersFrequency: [null, Validators.required],
      weeklyStartDay: [null],
      weeklyEndDay: [null],
      assetSearchFrequency: [null],
      loadSearchFrequency: [null],
      autoCalculateFrequency: [null],
      voucherJobFrequency: [null],
      sequencialType: [true],
      dateTimeSequencial: [''],
      daySequencial: [''],
      dateTimeLoad: [''],
      dayLoad: [''],
      dateTimeAsset: [''],
      dayAsset: [''],
      dateTimeAutoCalculate: [''],
      dayAutoCalculate: [''],
      dateTimeVoucher: [''],
      dayVoucher: [''],
      selectSchedulersMonth: [''],
      sequencialSpecialDaysOfMonth: [''],
      sequencialLastDaysOfMonth: [''],
      assetSpecialDaysOfMonth: [''],
      assetLastDaysOfMonth: [''],
      loadSpecialDaysOfMonth: [''],
      loadLastDaysOfMonth: [''],
      autoCalculateSpecialDaysOfMonth: [''],
      autoCalculateLastDaysOfMonth: [''],
      voucherSpecialDaysOfMonth: [''],
      voucherLastDaysOfMonth: [''],
      initialVoucherCharge: ['']
    });

    this.myForm = this.fb.group({
      sequencialdaysOftheWeek: [null],
      sequencialdatepicker: [null],
      assetdaysOftheWeek: [null],
      assetdatepicker: [null],
      loaddaysOftheWeek: [null],
      loaddatepicker: [null],
      autoCalculatedaysOftheWeek: [null],
      autoCalculatedatepicker: [null],
      voucherdaysOftheWeek: [null],
      voucherdatepicker: [null],
    });
    this.countryForm.controls['countryCode'].valueChanges.subscribe(res => {
      this.onboardCountryCode = res;
      if (res === 'USA') {
        this.isShowFrequencyContent = true;
      } else {
        this.isShowFrequencyContent = false;
        this.countryForm.controls['sequencialType'].patchValue(true);
        this.isShowInputBox = true;
        this.isShowFrequency = false;
      }
    })
    if (this.countryForm.value.sequencialType === true) {
      this.isShowInputBox = true;
    }
    this.dateConfig = {
      appendTo: 'body',
      opens: 'left',
      drops: 'up',
      firstDayOfWeek: 'mo',
      format: 'YYYY-MM-DD HH:mm',
      isDayDisabledCallback: (date: Moment) => {
        return (date.diff(moment().utc().format('YYYY-MM-DD'), 'days') < 0);
      },
      max: this.maxDate,
      min: this.minDate,
      disableKeypress: false,
      unSelectOnClick: true,
      closeOnSelect: true
    }
    this.dayConfig = {
      appendTo: 'body',
      drops: 'down',
      firstDayOfWeek: 'su',
      format: 'HH:mm',
      max: this.maxDate,
      min: this.minDate,
      disableKeypress: false,
      unSelectOnClick: true,
      closeOnSelect: true
    }
    this.years = this.generateYears(2024, 2050);
    this.selectedYear = this.years[0];
    this.getAllTimeZones();
    this.calendarstatusService.calendarStatus$.subscribe(status => {
      this.calendarStatus = status;
    });
    this.countryService.countryVal$.subscribe((countryValue: Object) => {
      this.countryForm.setValue(countryValue);
      this.initialVoucherCharge = parseFloat(countryValue['initialVoucherCharge']) || 1;
    });
    this.calendarService.calendarData$.subscribe((result: Object) => {
      this.monthsOnSelectedYears = result['months'];
    });
  }

  getAllTimeZones() {
    this.loader.startLoad();
    this.dfManagementService.getAllTimeZones()
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe((timezone: TimeZone[]) => {
        this.timeZoneList = timezone['data'];
      }, (error: HttpErrorResponse) => {
        this.toastr.error(error['error_message'] || this.translate.instant('df-management.df-admin.form.error-fetching-timezones')
        );
      });
  }

  onCloseClick() {
    this.isFlag = false;
    this.resetCountryData();
    this.countryForm.patchValue({
      initialVoucherCharge: 1
    });
    this.countryClickEmitter.emit();
    this.isShowInputBox = true;
    this.isShowFrequency = false;
    this.calendarStatus = false;
  }

  resetCountryData() {
    this.resetDfCountryForm();
    this.resetData();
    this.countryForm.controls['sequencialType'].patchValue(true);
  }

  confirmData() {
    this.isPopupModel = false;
    this.countryEmitter.emit();
  }

  resetDfCountryForm() {
    this.countryForm.reset();
    this.myForm.reset();
    this.autoCalculateSearchTime = '';
    this.loadSearchTime = '';
    this.assetSearchTime = '';
    this.voucherJobSearchTime = '';
    this.sequencialSearchTime = ''
    this.fixedCharge = '';
  }

  resetSequencial() {
    if (this.isChecked === true) {
      this.countryForm.controls['fixedChargesFrequency'].reset();
      this.countryForm.controls['selectSchedulersFrequency'].reset();
      this.countryForm.controls['voucherJobFrequency'].reset();
    } else {
      this.countryForm.controls['selectSchedulersFrequency'].reset();
      this.countryForm.controls['assetSearchFrequency'].reset();
      this.countryForm.controls['loadSearchFrequency'].reset();
      this.countryForm.controls['autoCalculateFrequency'].reset();
      this.countryForm.controls['voucherJobFrequency'].reset();
    }
  }

  changeFixedChargesFrequency(event: FixedChargesFrequency) {
    this.fixedCharge = event?.charges;
    if (event.charges === 'Custom') {
      this.countryForm.controls['fixedChargesFrequency'].setValue(event.charges);
      this.countryService.setCountryValue(this.countryForm.value);
      this.openModal();
      this.cd.detectChanges();
    }
  }

  changeAssetFrequency(event: FrequencyTime) {
    this.isAssetSearch = false;
    this.myForm.controls['assetdatepicker'].reset();
    this.countryForm.controls['dateTimeAsset'].reset();
    this.countryForm.controls['dayAsset'].reset();
    this.countryForm.controls['assetSpecialDaysOfMonth'].reset();
    this.countryForm.controls['assetLastDaysOfMonth'].reset();
    this.assetListOfDays = [];
    this.specificDateAsset = '';
    this.selectedCheckAssetboxes.clear();
    this.assetSearchTime = event?.frequency;
  }

  changeSequencalFrequency(event: FrequencyTime) {
    this.isSequencial = false;
    this.myForm.controls['sequencialdatepicker'].reset();
    this.countryForm.controls['dateTimeSequencial'].reset();
    this.countryForm.controls['daySequencial'].reset();
    this.countryForm.controls['sequencialSpecialDaysOfMonth'].reset();
    this.countryForm.controls['sequencialLastDaysOfMonth'].reset();
    this.sequencialListOfDays = [];
    this.specificDateSequencial = '';
    this.selectedCheckSequencialboxes.clear();
    this.sequencialSearchTime = event?.frequency;
  }

  changeLoadFrequency(event: FrequencyTime) {
    this.isLoadSearch = false;
    this.isAssetSearch = false;
    this.myForm.controls['loaddatepicker'].reset();
    this.countryForm.controls['dateTimeLoad'].reset();
    this.countryForm.controls['dayLoad'].reset();
    this.countryForm.controls['loadSpecialDaysOfMonth'].reset();
    this.countryForm.controls['loadLastDaysOfMonth'].reset();
    this.loadListOfDays = [];
    this.specificDateLoad = '';
    this.selectedCheckloadboxes.clear();
    this.loadSearchTime = event?.frequency;
  }

  changeAutoFrequency(event: FrequencyTime) {
    this.isAutoCalculateSearch = false;
    this.isLoadSearch = false;
    this.myForm.controls['autoCalculatedatepicker'].reset();
    this.countryForm.controls['dateTimeAutoCalculate'].reset();
    this.countryForm.controls['dayAutoCalculate'].reset();
    this.countryForm.controls['autoCalculateSpecialDaysOfMonth'].reset();
    this.countryForm.controls['autoCalculateLastDaysOfMonth'].reset();
    this.autoCalculateListOfDays = [];
    this.specificDateCalculate = '';
    this.selectedCheckAutoCalboxes.clear();
    this.autoCalculateSearchTime = event?.frequency;
  }

  changeVoucherFrequency(event: FrequencyTime) {
    this.myForm.controls['assetdaysOftheWeek'].reset();
    this.isVoucherSearch = false;
    this.isAutoCalculateSearch = false;
    this.isSequencial = false;
    this.myForm.controls['voucherdatepicker'].reset();
    this.countryForm.controls['dayVoucher'].reset();
    this.countryForm.controls['dateTimeVoucher'].reset();
    this.countryForm.controls['voucherSpecialDaysOfMonth'].reset();
    this.countryForm.controls['voucherLastDaysOfMonth'].reset();
    this.voucherListOfDays = [];
    this.specificDateVoucher = '';
    this.selectedCheckVoucherboxes.clear();
    this.voucherJobSearchTime = event?.frequency;
  }

  onChange(value: boolean) {
    this.resetSequencial();
    this.isChecked = value;
    if (value === true) {
      this.isShowFrequency = false;
      this.selectedCheckSequencialboxes.clear();
      this.selectedCheckAssetboxes.clear();
      this.selectedCheckloadboxes.clear();
      this.selectedCheckAutoCalboxes.clear();
      this.selectedCheckVoucherboxes.clear();
      this.isShowInputBox = true;
      this.assetSearchTime = '';
      this.voucherJobSearchTime = '';
      this.sequencialSearchTime = ''
      this.isVoucherSearch = false;
    } else {
      if (this.onboardCountryCode === 'USA') {
        this.isShowFrequency = false;
      } else {
        this.isShowFrequency = true;
      }
      this.selectedCheckVoucherboxes.clear();
      this.isShowInputBox = false;
      this.autoCalculateSearchTime = '';
      this.loadSearchTime = '';
      this.assetSearchTime = '';
      this.voucherJobSearchTime = '';
      this.isVoucherSearch = false;

    }
  };

  toggleCheckbox(value: string, content: string) {
    switch (content) {
      case 'sequencial':
      if (this.selectedCheckSequencialboxes.has(value)) {
        this.selectedCheckSequencialboxes.delete(value);
        this.sequencialListOfDays.forEach((item: any, index: number)  => {
          if (value['Value'] === item['Value']) {
            this.sequencialListOfDays.splice(index, 1);
          }
        })
      } else {
        this.selectedCheckSequencialboxes.add(value);
        this.selectedCheckSequencialboxes.forEach((element: any) => {
          this.sequencialListOfDays.push(element);
          const uniqueArray = Array.from(new Set(this.sequencialListOfDays));
          this.sequencialListOfDays = uniqueArray;
        });
      }
      return this.sequencialListOfDays;
      case 'assetSearch':
        if (this.selectedCheckAssetboxes.has(value)) {
          this.selectedCheckAssetboxes.delete(value);
          this.assetListOfDays.forEach((item: any, index: number)  => {
            if (value['Value'] === item['Value']) {
              this.assetListOfDays.splice(index, 1);
            }
          })
        } else {
          this.selectedCheckAssetboxes.add(value);
          this.selectedCheckAssetboxes.forEach((element: any) => {
            this.assetListOfDays.push(element);
            const uniqueArray = Array.from(new Set(this.assetListOfDays));
            this.assetListOfDays = uniqueArray;
          });
        }
        return this.assetListOfDays;
      case 'loadSearch':
        if (this.selectedCheckloadboxes.has(value)) {
          this.selectedCheckloadboxes.delete(value);
          this.loadListOfDays.forEach((item: any, index: number)  => {
            if (value['Value'] === item['Value']) {
              this.loadListOfDays.splice(index, 1);
            }
          })
        } else {
          this.selectedCheckloadboxes.add(value);
          this.selectedCheckloadboxes.forEach((element: any) => {
            this.loadListOfDays.push(element);
            const uniqueArray = Array.from(new Set(this.loadListOfDays));
            this.loadListOfDays = uniqueArray;
          });
        }
        return this.loadListOfDays;
      case 'autoCalculateSearch':
        if (this.selectedCheckAutoCalboxes.has(value)) {
          this.selectedCheckAutoCalboxes.delete(value);
          this.autoCalculateListOfDays.forEach((item: any, index: number)  => {
            if (value['Value'] === item['Value']) {
              this.autoCalculateListOfDays.splice(index, 1);
            }
          })
        } else {
          this.selectedCheckAutoCalboxes.add(value);
          this.selectedCheckAutoCalboxes.forEach((element: any) => {
            this.autoCalculateListOfDays.push(element);
            const uniqueArray = Array.from(new Set(this.autoCalculateListOfDays));
            this.autoCalculateListOfDays = uniqueArray;
          });
        }
        return this.autoCalculateListOfDays;
      case 'voucherSearch':
        if (this.selectedCheckVoucherboxes.has(value)) {
          this.selectedCheckVoucherboxes.delete(value);
          this.voucherListOfDays.forEach((item: any, index: number)  => {
            if (value['Value'] === item['Value']) {
              this.voucherListOfDays.splice(index, 1);
            }
          })
        } else {
          this.selectedCheckVoucherboxes.add(value);
          this.selectedCheckVoucherboxes.forEach((element: any) => {
            this.voucherListOfDays.push(element);
            const uniqueArray = Array.from(new Set(this.voucherListOfDays));
            this.voucherListOfDays = uniqueArray;
          });
        }
        return this.voucherListOfDays;
    }
  }

  resetData() {
    this.myForm.controls['sequencialdaysOftheWeek'].reset();
    this.myForm.controls['assetdaysOftheWeek'].reset();
    this.myForm.controls['loaddaysOftheWeek'].reset();
    this.myForm.controls['autoCalculatedaysOftheWeek'].reset();
    this.myForm.controls['voucherdaysOftheWeek'].reset();
    this.selectedCheckSequencialboxes.clear();
      this.selectedCheckAssetboxes.clear();
      this.selectedCheckloadboxes.clear();
      this.selectedCheckAutoCalboxes.clear();
      this.selectedCheckVoucherboxes.clear();
  }

  takeAction(actionValue: string) {
    const sequencialList = [];
    const voucherList = [];
    const assetList = [];
    const loadList = [];
    const autoCalculateList = [];
    const sequencialTime = this.myForm.value.sequencialdatepicker;
    const voucherTime = this.myForm.value.voucherdatepicker;
    const assetTime = this.myForm.value.assetdatepicker;
    const loadTime = this.myForm.value.loaddatepicker;
    const autoCalculateTime = this.myForm.value.autoCalculatedatepicker;
    if (sequencialTime && this.sequencialListOfDays) {
      const sequencailDaysList = [];
        this.sequencialListOfDays?.forEach(daysList => {
          sequencailDaysList.push(daysList['Name']);
          sequencialList.push(daysList['Value']);
        });
        this.countryForm.controls['dateTimeSequencial'].patchValue(sequencailDaysList + ' ' + sequencialTime);
    } else {
      const sequencailDaysList = [];
      this.sequencialListOfDays.forEach(daysList => {
        sequencailDaysList.push(daysList['Name']);
        sequencialList.push(daysList['Value']);
      });
      this.countryForm.controls['daySequencial'].patchValue(sequencailDaysList);
    }
    if (voucherTime && this.voucherListOfDays) {
      const voucherDaysList = [];
      this.voucherListOfDays.forEach(daysList => {
        voucherDaysList.push(daysList['Name']);
        voucherList.push(daysList['Value']);
      });
      this.countryForm.controls['dateTimeVoucher'].patchValue(voucherDaysList + ' ' + voucherTime);
    } else {
      const voucherDaysList = [];
      this.voucherListOfDays.forEach(daysList => {
        voucherDaysList.push(daysList['Name']);
        voucherList.push(daysList['Value']);
      });
      this.countryForm.controls['dayVoucher'].patchValue(voucherDaysList);
    }
    if (assetTime && this.assetListOfDays) {
      const assetDaysList = [];
      this.assetListOfDays.forEach(daysList => {
        assetDaysList.push(daysList['Name']);
        assetList.push(daysList['Value']);
      });
      this.countryForm.controls['dateTimeAsset'].patchValue(assetDaysList + ' ' + assetTime);
    } else {
      const assetDaysList = [];
      this.assetListOfDays.forEach(daysList => {
        assetDaysList.push(daysList['Name']);
        assetList.push(daysList['Value']);
      });
      this.countryForm.controls['dayAsset'].patchValue(assetDaysList);
    }
    if (loadTime && this.loadListOfDays) {
      const loadDaysList = [];
      this.loadListOfDays.forEach(daysList => {
        loadDaysList.push(daysList['Name']);
        loadList.push(daysList['Value']);
      });
      this.countryForm.controls['dateTimeLoad'].patchValue(loadDaysList + ' ' + loadTime);
    } else {
      const loadDaysList = [];
      this.loadListOfDays.forEach(daysList => {
        loadDaysList.push(daysList['Name']);
        loadList.push(daysList['Value']);
      });
      this.countryForm.controls['dayLoad'].patchValue(loadDaysList);
    }
    if (autoCalculateTime  && this.autoCalculateListOfDays) {
      const autoCalculateDaysList = [];
      this.autoCalculateListOfDays.forEach(daysList => {
        autoCalculateDaysList.push(daysList['Name']);
        autoCalculateList.push(daysList['Value']);
      });
      this.countryForm.controls['dateTimeAutoCalculate'].patchValue(autoCalculateDaysList + ' ' + autoCalculateTime);
    } else {
      const autoCalculateDaysList = [];
      this.autoCalculateListOfDays.forEach(daysList => {
        autoCalculateDaysList.push(daysList['Name']);
        autoCalculateList.push(daysList['Value']);
      });
      this.countryForm.controls['dayAutoCalculate'].patchValue(autoCalculateDaysList);
    }
    const sequencialdatePickerTime =  sequencialTime ? sequencialTime.split(/[:\s]/) : '' ;
    const voucherdatePickerTime = voucherTime ? voucherTime.split(/[:\s]/) : '' ;
    const assetdatePickerTime = assetTime ? assetTime.split(/[:\s]/) : '' ;
    const loaddatePickerTime = loadTime ? loadTime.split(/[:\s]/) : '';
    const autoCalculatedatePickerTime = autoCalculateTime ? autoCalculateTime.split(/[:\s]/) : '';
    switch (actionValue) {
      case 'sequencial':
        this.sequencialTimeData = {
          daysOfWeek: sequencialList,
          instances: [
            {
              hour: sequencialdatePickerTime[0],
              minute: sequencialdatePickerTime[1]
            }
          ]
        }
        this.sequencialTimeData.instances.forEach(element => {
          this.daysOfSequencialTime = element;
        });
        this.isSequencial = false;
        return this.sequencialTimeData;
      case 'assetSearch':
        this.assetTimeData = {
          daysOfWeek: assetList,
          instances: [
            {
              hour: assetdatePickerTime[0],
              minute: assetdatePickerTime[1]
            }
          ]
        }
        this.assetTimeData.instances.forEach(element => {
          this.daysOfAssetTime = element;
        });
        this.isAssetSearch = false;
        return this.assetTimeData;
      case 'loadSearch':
        this.loadTimeData = {
          daysOfWeek: loadList,
          instances: [
            {
              hour: loaddatePickerTime[0],
              minute: loaddatePickerTime[1]
            }
          ]
        }
        this.loadTimeData.instances.forEach(element => {
          this.daysOfLoadTime = element;
        });
        this.isLoadSearch = false;
        return this.loadTimeData;
      case 'autoCalculateSearch':
        this.autoCalculateTimeData = {
          daysOfWeek: autoCalculateList,
          instances: [
            {
              hour: autoCalculatedatePickerTime[0],
              minute: autoCalculatedatePickerTime[1]
            }
          ]
        }
        this.autoCalculateTimeData.instances.forEach(element => {
          this.daysOfAutoCalculateTime = element;
        });
        this.isAutoCalculateSearch = false;
        return this.autoCalculateTimeData;
      case 'voucherSearch':
        this.voucherTimeData = {
          daysOfWeek: voucherList,
          instances: [
            {
              hour: voucherdatePickerTime[0],
              minute: voucherdatePickerTime[1]
            }
          ]
        }
        this.voucherTimeData.instances.forEach(element => {
          this.daysOfVoucherTime = element;
        });
        this.isVoucherSearch = false;
        return this.voucherTimeData;
    }
  }


  hideInput(showButton: string) {
    switch (showButton) {
      case 'sequencial':
        this.isVoucherSearch = false;
        return this.isSequencial = !this.isSequencial;
      case 'assetSearch':
        this.isLoadSearch = false;
        this.isAutoCalculateSearch = false;
        this.isVoucherSearch = false;
        return this.isAssetSearch = !this.isAssetSearch;
      case 'loadSearch':
        this.isAssetSearch = false;
        this.isAutoCalculateSearch = false;
        this.isVoucherSearch = false;
        return this.isLoadSearch = !this.isLoadSearch;
      case 'autoCalculateSearch':
        this.isAssetSearch = false;
        this.isLoadSearch = false;
        this.isVoucherSearch = false;
        return this.isAutoCalculateSearch = !this.isAutoCalculateSearch;
      case 'voucherSearch':
        this.isSequencial = false;
        this.isAssetSearch = false;
        this.isLoadSearch = false;
        this.isAutoCalculateSearch = false;
        return this.isVoucherSearch = !this.isVoucherSearch;
    }
  }

  getInstances() {
    if (this.countryForm.value?.selectSchedulersFrequency?.frequency === 'once a day') {
      this.SchedulersFrequency = {
        hour: this.daysOfSequencialTime.hour,
        minute: this.daysOfSequencialTime.minute
      }
      this.daysOfSequencialWeeks = this.sequencialTimeData.daysOfWeek;
    } else if (this.countryForm.value?.selectSchedulersFrequency?.frequency === 'every six hours') {
      this.SchedulersFrequency = null;
      this.daysOfSequencialWeeks = this.sequencialTimeData.daysOfWeek;
    } else if (this.countryForm.value?.selectSchedulersFrequency?.frequency === 'last day of month') {
      if (this.countryForm.value?.sequencialLastDaysOfMonth) {
        this.daysOfSequencialTime = this.countryForm.value?.sequencialLastDaysOfMonth.split(/[:\s]/);
        this.daysOfSequencialWeeks = [];
        this.SchedulersFrequency = {
          hour: this.daysOfSequencialTime[0],
          minute: this.daysOfSequencialTime[1]
        }
      } else {
        this.SchedulersFrequency = null;
      }
    } else if (this.countryForm.value?.selectSchedulersFrequency?.frequency === 'specific day of month') {
      let sequencialdateandPickerTime;
      if (this.countryForm.value?.sequencialSpecialDaysOfMonth) {
        sequencialdateandPickerTime = this.countryForm.value?.sequencialSpecialDaysOfMonth.split(' ');
        this.specificDateSequencial = moment(sequencialdateandPickerTime[0]).format('DD');
        this.daysOfSequencialTime = sequencialdateandPickerTime[1].split(/[:\s]/);
        this.daysOfSequencialWeeks = [];
        this.SchedulersFrequency = {
          hour: this.daysOfSequencialTime[0],
          minute: this.daysOfSequencialTime[1]
        }
      } else {
        this.SchedulersFrequency = null;
      }
    } else {
      this.SchedulersFrequency = null;
      this.daysOfSequencialWeeks = [];
    }

    if (this.countryForm.value?.voucherJobFrequency?.frequency === 'once a day') {
      this.voucherJobFrequency = {
        hour: this.daysOfVoucherTime.hour,
        minute: this.daysOfVoucherTime.minute
      }
      this.daysOfVoucherWeeks = this.voucherTimeData.daysOfWeek;
    } else if (this.countryForm.value?.voucherJobFrequency?.frequency === 'every six hours') {
      this.voucherJobFrequency = null;
      this.daysOfVoucherWeeks = this.voucherTimeData.daysOfWeek;
    } else if (this.countryForm.value?.voucherJobFrequency?.frequency === 'last day of month') {
      if (this.countryForm.value?.voucherLastDaysOfMonth) {
        this.daysOfVoucherTime = this.countryForm.value?.voucherLastDaysOfMonth.split(/[:\s]/);
        this.daysOfVoucherWeeks = [];
        this.voucherJobFrequency = {
          hour: this.daysOfVoucherTime[0],
          minute: this.daysOfVoucherTime[1]
        }
      } else {
        this.voucherJobFrequency = null;
      }
    } else if (this.countryForm.value?.voucherJobFrequency?.frequency === 'specific day of month') {
      let voucherdateandPickerTime;
      if (this.countryForm.value?.voucherSpecialDaysOfMonth) {
        voucherdateandPickerTime = this.countryForm.value?.voucherSpecialDaysOfMonth.split(' ');
        this.specificDateVoucher = moment(voucherdateandPickerTime[0]).format('DD');
        this.daysOfVoucherTime = voucherdateandPickerTime[1].split(/[:\s]/);
        this.daysOfVoucherWeeks = [];
        this.voucherJobFrequency = {
          hour: this.daysOfVoucherTime[0],
          minute: this.daysOfVoucherTime[1]
        }
      } else {
        this.voucherJobFrequency = null;
      }
    } else {
      this.voucherJobFrequency = null;
      this.daysOfVoucherWeeks = [];
    }

    if (this.countryForm.value?.assetSearchFrequency?.frequency === 'once a day') {
      this.assetSearchFrequency = {
        hour: this.daysOfAssetTime.hour,
        minute: this.daysOfAssetTime.minute
      }
      this.daysOfAssetWeeks = this.assetTimeData.daysOfWeek;
    } else if (this.countryForm.value?.assetSearchFrequency?.frequency === 'every six hours') {
      this.assetSearchFrequency = null;
      this.daysOfAssetWeeks = this.assetTimeData.daysOfWeek;
    } else if (this.countryForm.value?.assetSearchFrequency?.frequency === 'last day of month') {
      if (this.countryForm.value?.assetLastDaysOfMonth) {
        this.daysOfAssetTime = this.countryForm.value?.assetLastDaysOfMonth.split(/[:\s]/);
        this.daysOfAssetWeeks = [];
        this.assetSearchFrequency = {
          hour: this.daysOfAssetTime[0],
          minute: this.daysOfAssetTime[1]
        }
      } else {
        this.assetSearchFrequency = null;
      }
    } else if (this.countryForm.value?.assetSearchFrequency?.frequency === 'specific day of month') {
      let assetdateandPickerTime;
      if (this.countryForm.value?.assetSpecialDaysOfMonth) {
        assetdateandPickerTime = this.countryForm.value?.assetSpecialDaysOfMonth.split(' ');
        this.specificDateAsset = moment(assetdateandPickerTime[0]).format('DD');
        this.daysOfAssetTime = assetdateandPickerTime[1].split(/[:\s]/);
        this.daysOfAssetWeeks = [];
        this.assetSearchFrequency = {
          hour: this.daysOfAssetTime[0],
          minute: this.daysOfAssetTime[1]
        }
      } else {
        this.assetSearchFrequency = null;
      }
    } else {
      this.assetSearchFrequency = null;
      this.daysOfAssetWeeks = [];
    }

    if (this.countryForm.value?.loadSearchFrequency?.frequency === 'once a day') {
      this.loadSearchFrequency = {
        hour: this.daysOfLoadTime.hour,
        minute: this.daysOfLoadTime.minute
      }
      this.daysOfLoadWeeks = this.loadTimeData.daysOfWeek;
    } else if (this.countryForm.value?.loadSearchFrequency?.frequency === 'every six hours') {
      this.loadSearchFrequency = null;
      this.daysOfLoadWeeks = this.loadTimeData.daysOfWeek;
    } else if (this.countryForm.value?.loadSearchFrequency?.frequency === 'last day of month') {
      if (this.countryForm.value?.loadLastDaysOfMonth) {
        this.daysOfLoadTime = this.countryForm.value?.loadLastDaysOfMonth.split(/[:\s]/);
        this.daysOfLoadWeeks = [];
        this.loadSearchFrequency = {
          hour: this.daysOfLoadTime[0],
          minute: this.daysOfLoadTime[1]
        }
      } else {
        this.loadSearchFrequency = null;
      }
    } else if (this.countryForm.value?.loadSearchFrequency?.frequency === 'specific day of month') {
      let loaddateandPickerTime;
      if (this.countryForm.value?.loadSpecialDaysOfMonth) {
        loaddateandPickerTime = this.countryForm.value?.loadSpecialDaysOfMonth.split(' ');
        this.specificDateLoad = moment(loaddateandPickerTime[0]).format('DD');
        this.daysOfLoadTime = loaddateandPickerTime[1].split(/[:\s]/);
        this.daysOfLoadWeeks = [];
        this.loadSearchFrequency = {
          hour: this.daysOfLoadTime[0],
          minute: this.daysOfLoadTime[1]
        }
      } else {
        this.loadSearchFrequency = null;
      }
    } else {
      this.loadSearchFrequency = null;
      this.daysOfLoadWeeks = [];
    }

    if (this.countryForm.value?.autoCalculateFrequency?.frequency === 'once a day') {
      this.autoCalculateFrequency = {
        hour: this.daysOfAutoCalculateTime.hour,
        minute: this.daysOfAutoCalculateTime.minute
      }
      this.daysOfAutoCalculateWeeks = this.autoCalculateTimeData.daysOfWeek;
    } else if (this.countryForm.value?.autoCalculateFrequency?.frequency === 'every six hours') {
      this.autoCalculateFrequency = null;
      this.daysOfAutoCalculateWeeks = this.autoCalculateTimeData.daysOfWeek;
    } else if (this.countryForm.value?.autoCalculateFrequency?.frequency === 'last day of month') {
      if (this.countryForm.value?.autoCalculateLastDaysOfMonth) {
        this.daysOfAutoCalculateTime = this.countryForm.value?.autoCalculateLastDaysOfMonth.split(/[:\s]/);
        this.daysOfAutoCalculateWeeks = [];
        this.autoCalculateFrequency = {
          hour: this.daysOfAutoCalculateTime[0],
          minute: this.daysOfAutoCalculateTime[1]
        }
      } else {
        this.autoCalculateFrequency = null;
      }
    } else if (this.countryForm.value?.autoCalculateFrequency?.frequency === 'specific day of month') {
      let autodateandPickerTime;
      if (this.countryForm.value?.autoCalculateSpecialDaysOfMonth) {
        autodateandPickerTime = this.countryForm.value?.autoCalculateSpecialDaysOfMonth.split(' ');
        this.specificDateCalculate = moment(autodateandPickerTime[0]).format('DD');
        this.daysOfAutoCalculateTime = autodateandPickerTime[1].split(/[:\s]/);
        this.daysOfAutoCalculateWeeks = [];
        this.autoCalculateFrequency = {
          hour: this.daysOfAutoCalculateTime[0],
          minute: this.daysOfAutoCalculateTime[1]
        }
      } else {
        this.autoCalculateFrequency = null;
      }
    } else {
      this.autoCalculateFrequency = null;
      this.daysOfAutoCalculateWeeks = [];
    }
  }

  submit() {
    this.loader.startLoad();
    this.getInstances();
    const initialVoucherChargeValue = this.countryForm.value.initialVoucherCharge !== '' ? parseFloat(this.countryForm.value.initialVoucherCharge) : '';
    this.fixedCharge = this.fixedCharge ? this.fixedCharge : this.countryForm.value.fixedChargesFrequency;
    let frequencyCharges;
    let monthlyDetails: DFMonthlyDataRequest[];
    switch (this.fixedCharge) {
      case 'Daily':
        frequencyCharges = {
          country_code: this.countryForm.value.countryCode,
          fixed_charge_frequency: this.fixedCharge,
          initial_voucher_charge: initialVoucherChargeValue,
        }
        break;
      case 'Weekly':
        frequencyCharges = {
          fixed_charge_frequency: this.fixedCharge,
          start_day: this.countryForm.value.weeklyStartDay?.Value,
          end_day: this.countryForm.value.weeklyEndDay?.Value,
          country_code: this.countryForm.value.countryCode,
          initial_voucher_charge: initialVoucherChargeValue,
        }
        break;
      case 'Monthly':
        frequencyCharges = {
          country_code: this.countryForm.value.countryCode,
          fixed_charge_frequency: this.fixedCharge,
          initial_voucher_charge: initialVoucherChargeValue,
        }
        break;
      case 'Custom':
        frequencyCharges = {
          country_code: this.countryForm.value.countryCode,
          fixed_charge_frequency: this.fixedCharge,
          initial_voucher_charge: initialVoucherChargeValue,
        };
        monthlyDetails = this.monthsOnSelectedYears.map(month => DFMonthlyDataDto.toDto(month))
          break;
      default:
        frequencyCharges = {}

    }
    let body;
    if (this.countryForm.value.sequencialType === true) {
      if (this.onboardCountryCode === 'USA') {
        body = {
          country: {
            country: this.countryForm.value.countryName,
            country_code: this.countryForm.value.countryCode,
            timezone: this.countryForm.value.timeZone?.time_zone,
            country_job_frequency_details: frequencyCharges
          },
          jobScheduleRequests: {
            sequentialJobUSA: {
              daysOfWeek: this.daysOfSequencialWeeks,
              frequency: this.countryForm.value.selectSchedulersFrequency?.value,
              instances: [this.SchedulersFrequency],
              specificDays: [this.specificDateSequencial],
            },
            voucherupdatejob: {
              daysOfWeek: this.daysOfVoucherWeeks,
              frequency: this.countryForm.value.voucherJobFrequency?.value,
              specificDays: [this.specificDateVoucher],
              instances: [
                this.voucherJobFrequency
              ]
            }
          }
        }
      } else {
        body = {
          country: {
            country: this.countryForm.value.countryName,
            country_code: this.countryForm.value.countryCode,
            timezone: this.countryForm.value.timeZone?.time_zone,
            country_job_frequency_details: frequencyCharges,
          },
          jobScheduleRequests: {
            sequentialJob: {
              daysOfWeek: this.daysOfSequencialWeeks,
              frequency: this.countryForm.value.selectSchedulersFrequency?.value,
              instances: [this.SchedulersFrequency],
              specificDays: [this.specificDateSequencial],
            },
            assetsjob: {},
            loadsjob: {},
            calculateautoloadingchargesjob: {},
            voucherupdatejob: {
              daysOfWeek: this.daysOfVoucherWeeks,
              frequency: this.countryForm.value.voucherJobFrequency?.value,
              specificDays: [this.specificDateVoucher],
              instances: [
                this.voucherJobFrequency
              ]
            }
          }
        }
      }
    } else {
      if (this.onboardCountryCode === 'USA') {
        body = {
          country: {
            country: this.countryForm.value.countryName,
            country_code: this.countryForm.value.countryCode,
            timezone: this.countryForm.value.timeZone?.time_zone,
            country_job_frequency_details: frequencyCharges
          },
          jobScheduleRequests: {
            carriersjob: {
              daysOfWeek: this.daysOfAssetWeeks,
              frequency: this.countryForm.value.assetSearchFrequency?.value,
              specificDays: [this.specificDateAsset],
              instances: [
                this.assetSearchFrequency
              ]
            },
            loadsjob: {
              daysOfWeek: this.daysOfLoadWeeks,
              frequency: this.countryForm.value.loadSearchFrequency?.value,
              specificDays: [this.specificDateLoad],
              instances: [
                this.loadSearchFrequency
              ]
            },
            voucherupdatejob: {
              daysOfWeek: this.daysOfVoucherWeeks,
              frequency: this.countryForm.value.voucherJobFrequency?.value,
              specificDays: [this.specificDateVoucher],
              instances: [
                this.voucherJobFrequency
              ]
            }
          }
        }
      } else {
      body = {
        country: {
          country: this.countryForm.value.countryName,
          country_code: this.countryForm.value.countryCode,
          timezone: this.countryForm.value.timeZone?.time_zone,
          country_job_frequency_details: frequencyCharges
        },
        jobScheduleRequests: {
          sequentialJob: {},
          assetsjob: {
            daysOfWeek: this.daysOfAssetWeeks,
            frequency: this.countryForm.value.assetSearchFrequency?.value,
            specificDays: [this.specificDateAsset],
            instances: [
              this.assetSearchFrequency
            ]
          },
          loadsjob: {
            daysOfWeek: this.daysOfLoadWeeks,
            frequency: this.countryForm.value.loadSearchFrequency?.value,
            specificDays: [this.specificDateLoad],
            instances: [
              this.loadSearchFrequency
            ]
          },
          calculateautoloadingchargesjob: {
            daysOfWeek: this.daysOfAutoCalculateWeeks,
            frequency: this.countryForm.value.autoCalculateFrequency?.value,
            specificDays: [this.specificDateCalculate],
            instances: [
              this.autoCalculateFrequency
            ]
          },
          voucherupdatejob: {
            daysOfWeek: this.daysOfVoucherWeeks,
            frequency: this.countryForm.value.voucherJobFrequency?.value,
            specificDays: [this.specificDateVoucher],
            instances: [
              this.voucherJobFrequency
            ]
          }
        }
      }
    }
    }
    this.dfManagementService.addOnBordingCountry(body, this.countryForm.value.sequencialType)
    .pipe(finalize(() => this.loader.stopLoad()))
    .subscribe((succeed) => {
      this.isFlag = false;
      this.isPopupModel = true;
      this.resetCountryData();
    }, (error: HttpErrorResponse) => {
      this.toastr.error(error.error.message || this.translate.instant('df-management.df-admin.form.error-post-data'));
    });
  }

  numberWithAllowColon(event) {
   const key = event.charCode;
    return ((key > 47 && key < 58) || key === 58);
  }

  numberWithAllowSpecialChar(event) {
   const key = event.charCode;
    return ((key > 47 && key < 58) || key === 58 || key === 45);
  }

  openModal(): void {
    this.isModalOpen = true;
    this.isFlag = false;
  }

  closeModal(): void {
    this.isModalOpen = false;
  }

  calendarDatesNavigation(): void {
    this.navigationService.dfVariableChargesManagemnt().addCalendar().go();
    this.calendarService.setSelectedYear(this.selectedYear);
    this.calendarService.setSelectedCountry(this.countryForm.value.countryCode);
    this.calendarService.setFormType('OnBoardCountry');
  }

  generateYears(startYear: number, endYear: number): number[] {
    const years: number[] = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year);
    }
    return years;
  }

  editCalendar() {
    this.navigationService.dfVariableChargesManagemnt().addCalendar().go();
  }
}
